module.exports = __webpack_public_path__ + "static/media/portrait.7a5194b1.svg";